import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "PRODUCT_REQUEST_ERROR":
            return action.error;

        case "PRODUCT_REQUEST_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "PRODUCT_REQUEST_LOADING":
            return action.loading;

        case "PRODUCT_REQUEST_RESET":
            return null;

        default:
            return state;
    }
}

export function retrieved(state = false, action) {
    switch (action.type) {
        case "PRODUCT_REQUEST_SUCCESS":
            return action.retrieved;

        case "PRODUCT_REQUEST_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved});